export const LANGUAGE_SELECTED_STORAGE_KEY = 'languageSelected';

export function getLocalStorageValue(key) {
  if (!key) {
    throw new Error('Key is required.');
  }
  return window.localStorage.getItem(key);
}

export function setLocalStorage(key, value) {
  if (!key || !value) {
    throw new Error('Invalid key or value!');
  }
  window.localStorage.setItem(key, value);
}

export function setCountryStorageIfNotExist(country) {
  const countryStorage = window.localStorage.getItem('Country');
  if (!countryStorage) {
    window.localStorage.setItem('Country', country);
  }
}
